'use client';
import { makeStyles, mergeClasses } from '@griffel/react';
import { getTooltipStyle } from '../../utilities/index';
export const areaChartClassNames = {
    tooltip: 'fui-ac__tooltip',
    root: '',
    xAxis: '',
    yAxis: '',
    legendContainer: '',
    hover: '',
    descriptionMessage: '',
    axisTitle: '',
    chartTitle: '',
    opacityChangeOnHover: '',
    shapeStyles: '',
    chartWrapper: '',
    svgTooltip: '',
    chart: '',
    axisAnnotation: '',
    plotContainer: '',
    annotationLayer: ''
};
const useStyles = makeStyles({
    tooltip: getTooltipStyle()
});
/**
 * Apply styling to the AreaChart slots based on the state
 */ export const useAreaChartStyles = (props)=>{
    const baseStyles = useStyles();
    return {
        tooltip: mergeClasses(areaChartClassNames.tooltip, baseStyles.tooltip /*props.styles?.tooltip*/ )
    };
};
